import * as yup from 'yup';

export const formDefaults = {
  imageFile: undefined,
  imgSrc: '',
  caption: '',
  contributorEmail: '',
  contributorInstagram: '',
  isHalfcourtHoop: false,
  location: {
    found: false,
    place_id: null,
    formatted_address: '',
    latitude: null,
    longitude: null,
    locality: '',
    zip: '',
    country: '',
    isNotConsideredExactAddress: false,
  },
};

export const validationSchema = yup.object({
  imageFile: yup.mixed().required(),
  caption: yup.string(),
  contributorEmail: yup.string().email().required(),
  contributorInstagram: yup.string().required(),
  isHalfcourtHoop: yup.bool(),
  location: yup.object().shape({
    found: false,
    place_id: null,
    formatted_address: '',
    latitude: null,
    longitude: null,
    locality: '',
    zip: '',
    country: '',
    isNotConsideredExactAddress: false,
  })
    .required(),
});
